import { Email, Link as LinkIcon, Location, People, Technology } from '@/components/Svg';
import t from '@/lib/localization';
import { ActionIcon, Card, createStyles, Grid } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';

const useStyles = createStyles((theme) => ({
  para: {
    fontSize: '14px',
    lineHeight: '24px',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    color: '#5C5C5C',
  },

  path: {
    fill: 'white',
  },
}));

export default function OrganizationSmallCard({ dictionary, organization, ...props }) {
  const { theme, classes } = useStyles();
  return (
    <Card
      padding="lg"
      style={{
        borderRadius: '12px',
      }}
      {...props}
      withBorder
    >
      <Grid>
        <Grid.Col span={12}>
          <div className="flex items-center">
            <Link
              href={`/organizations/${organization.slug ? organization.slug : organization.id}`}
              className="no-underline "
            >
              <Image
                height={50}
                width={50}
                radius="xl"
                src={organization.photoURL ?? '/images/user.svg'}
                className='rounded-full'
                alt="company Name"
              />
            </Link>
            <div className="flex flex-col ms-4">
              <Link
                href={`/organizations/${organization.slug ? organization.slug : organization.id}`}
                className="no-underline "
              >
                <h2
                  className={`${classes.title} p-0 hover:text-primary whitespace-nowrap m-0 transition-all duration-200`}
                >
                  {organization.name}
                </h2>
              </Link>
              <div className="flex items-center pt-2">
                <Location color="#A4A4A4" />
                <p className="p-0 m-0 text-sm ms-2 text-textGrey">{organization.location}</p>
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center mt-[16px]">
            <div className="flex flex-col">
              <div className="flex items-center text-primary">
                <Technology height="16" width="16" />
                <p className={`${classes.para} text-textGrey ms-2 m-0 text-[12px]`}>
                  {organization.type}
                </p>
              </div>
              <div className="flex items-center text-primary">
                <People height="16" width="16" />
                <p className={`${classes.para} text-textGrey ms-2 m-0 text-[12px]`}>
                  {t(dictionary.countEmployees, { count: organization.size })}
                </p>
              </div>
            </div>
            <div className="flex gap-2">
              <Link href={`tel:${organization.phoneNo}`} aria-label="Call">
                <ActionIcon className="text-primary border-solid border-primary rounded-full h-[32px] w-[32px] hover:bg-primary hover:text-white transaton ease-in duration-200">
                  <LinkIcon height="15px" width="15px" />
                </ActionIcon>
              </Link>
              <Link href={`mailto:${organization.businessEmail}`} aria-label="Email">
                <ActionIcon className="text-primary border-solid border-primary rounded-full h-[32px] w-[32px] ms-[7px] hover:bg-primary hover:text-white transaton ease-in duration-200">
                  <Email width="15px" height="11px" />
                </ActionIcon>
              </Link>
            </div>
          </div>
        </Grid.Col>
      </Grid>
    </Card>
  );
}
